module.exports = __webpack_public_path__ + "img/cliff-inner-shadow.ba33a257.png";